<template>
	<div class="new-substance">
		<NavBar v-if="admin" :admin="true" :items="items" />
		<Breadcrumbs v-else :items="items" />
		<v-main :class="admin ? 'ma-12' : 'pa-0'">
			<SubstanceForm :admin="admin" :drugInteractions="drugInteractions" />
		</v-main>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NavBar from "@/components/authentication/NavBar.vue";
import SubstanceForm from "@/components/products/SubstanceForm.vue";
import axios from "axios";

export default {
	name: "NewSubstance",
	components: {
		Breadcrumbs,
		SubstanceForm,
		NavBar
	},
	data: () => ({
		drugInteractions: []
	}),
	computed: {
		admin() {
			return this.$store.getters.hasRole('admin');
		},
		items() {
			if (this.admin) {
				return [
					{
						text: this.$gettext("Dashboard"),
						disabled: false,
						link: true,
						to: { name: "dashboard" }
					},
					{
						text: this.$gettext("Chinese Materia Medica"),
						disabled: false,
						link: true,
						to: { name: "admin-cmm", params: { admin: true } }
					},
					{
						text: this.$gettext("New Substance"),
						disabled: true,
						link: true
					}
				];
			} else {
				return [
					{
						text: this.$gettext("Settings"),
						disabled: true,
						link: true
					},
					{
						text: this.$gettext("Treatments"),
						disabled: false,
						link: true,
						to: { name: "settings", params: { tab: "treatments" } }
					},
					{
						text: this.$gettext("Chinese Materia Medica"),
						disabled: false,
						link: true,
						to: { name: "cmm" }
					},
					{
						text: this.$gettext("New Substance"),
						disabled: true,
						link: true
					}
				];
			}
		}
	},
	created() {
		axios
			.get("/mtc/substances/new")
			.then(response => {
				this.drugInteractions = response.data.medicine_interactions;
			})
			.catch(error => {
				console.log(error);
			});
	}
};
</script>